import {
    HOMEAWAY_AS_DISPLAY_STRING,
    VRBO_AS_DISPLAY_STRING
} from '../../../utils/constants';

import {appBannerCtaLinks} from '../appBannerConfig';

const getDisplayName = (travelerApp) => {
    return travelerApp &&
        travelerApp.toLowerCase() === HOMEAWAY_AS_DISPLAY_STRING.toLowerCase()
        ? HOMEAWAY_AS_DISPLAY_STRING
        : VRBO_AS_DISPLAY_STRING;
};

const getCtaLink = (travelerApp) => {
    return travelerApp ? appBannerCtaLinks[travelerApp.toLowerCase()] : null;
};

const getFormattedTitle = (title, formattedBrandName) => {
    return title && title.replace('{brand}', formattedBrandName);
};

const getDeviceMessage = (isAndroid, androidMessage, iOSMessage) => {
    return isAndroid ? androidMessage : iOSMessage;
};

export {getDisplayName, getCtaLink, getFormattedTitle, getDeviceMessage};
